import React from 'react';
import { InputField } from '../../components/common/forms';
import { Button, LinkButton, TextLink } from '../../components/common';
import { H2 } from '../../components/basic/Text';
import ServiceDescription from '../ServiceDescription';
import { ButtonContainer, FormContainer } from '../layoutComponents';
import FormError from '../../components/common/forms/FormError';
import { Routes } from '../../constants/routes';
import { scrollToTop } from '../../utils';
import { useMessageGetter } from 'react-message-context';

interface LoginFormProps {
  onSubmit: () => void;
  loginFailed: boolean;
  errorMessage: string;
}

const LoginForm: React.FC<LoginFormProps> = ({ onSubmit, loginFailed, errorMessage }) => {
  const translationPrefix = 'signin';
  const t = useMessageGetter(translationPrefix);

  return (
    <FormContainer>
      <H2>{t('title')}</H2>
      <ServiceDescription />
      <form onSubmit={onSubmit}>
        <InputField
          fieldPath="username"
          translationPrefix={translationPrefix}
          type="email"
          allowDefaultSubmit
          required
          dark
        />
        <InputField
          fieldPath="password"
          translationPrefix={translationPrefix}
          type="password"
          autoComplete="current-password"
          allowDefaultSubmit
          required
          dark
          togglePassword
        />
        {loginFailed && <FormError message={errorMessage} />}
        <ButtonContainer>
          <Button type="submit" id="submit" primary iconRight icon="arrowForward">
            {t('submit.button')}
          </Button>
          <LinkButton to={Routes.SIGN_UP}>{t('toRegistration')}</LinkButton>
          <TextLink to={Routes.RESET_PASSWORD} onClick={scrollToTop}>
            {t('forgotPassword')}
          </TextLink>
        </ButtonContainer>
      </form>
    </FormContainer>
  );
};

export default React.memo(LoginForm);
